/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Downgrade_Loss_ComplianceInputs */



/**
* | output |
* | --- |
* | "Compliance Copilot" |
*
* @param {Plan_Tab_Downgrade_Loss_ComplianceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_loss_compliance = /** @type {((inputs?: Plan_Tab_Downgrade_Loss_ComplianceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_Loss_ComplianceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance Copilot")
	return /** @type {LocalizedString} */ ("Compliance Copilot")
});